import { Routes, Route, Navigate } from "react-router-dom";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { DashboardHomeComponent } from "../dashboard/dashboard-home.component";
import { LoginForm } from "../auth/LoginForm";
import { AuthGuard } from "../../shared/guards/auth.guard";
import { MenuList } from "../../shared/enums/menu-lis";
import { HostersComponent } from "../../features/hosters/components/hosters.component";
import { UsersComponent } from "../../features/users/components/users.component";
import { AdsComponent } from "../../features/ads/components/ads.component";
import { SettingsComponent } from "../../features/settings/components/settings.component";
import { SupportComponent } from "../../features/supports/components/support.component";
import { ProfileComponent } from "../../features/profile/components/profile.component";

export const RootRoutes = () => {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<LoginForm />} />

      {/* Protected routes */}
      <Route element={<AuthGuard />}>
        <Route path="/" element={<DashboardComponent />}>
          <Route
            index
            element={<Navigate to={`/${MenuList.DASHBOARD}`} replace />}
          />
          <Route path={MenuList.DASHBOARD} element={<DashboardHomeComponent />} />
          <Route path={MenuList.HOSTERS} element={<HostersComponent />} />
          <Route path={MenuList.USERS} element={<UsersComponent />} />
          <Route path={MenuList.HOSTINGS} element={<AdsComponent />} />
          <Route path={MenuList.SETTINGS} element={<SettingsComponent />} />
          <Route path={MenuList.SUPPORT} element={<SupportComponent />} />
          <Route path={MenuList.PROFILE} element={<ProfileComponent />} />
        </Route>
      </Route>
    </Routes>
  );
};
